import React, { useEffect, useState } from "react";
import { StructuredListSkeleton } from "carbon-components-react";
import FormRadio from "./form_elements/form-radio";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";
import PlanHeader from "./plan-header";
import {PlanType} from "./../components/enums/plan-type";
import { buildDependents } from "./contact-builder";
import { isCourtOrdered } from "./is-court-ordered";
import { WarningHexFilled20 } from '@carbon/icons-react';
import { EnrollmentType } from "./enums/enrollment-type";
import Tiers from "./tiers";

const Plans = ({ type, disabled, reset, setDisabled }) => {
  const [plans, setPlans] = useState();
  const [plan, setPlan] = useState();
  const [planOption, setPlanOption] = useState();
  const { setValue, getValues,trigger } = useFormContext();
  const enrollments = useSelector((s) => s.enrollments);
  const [count, setcount] = useState(0);


  useEffect(() => {
    if (!Array.isArray(enrollments) && enrollments.plans) {
      const deps = buildDependents(enrollments);
      const filteredPlans = enrollments.plans.filter((plan) => plan.planType === type);
      filteredPlans.push({
        id: "WAIVED",
        name: "Waived Coverage",
        options: [],
        planType: type,
        providerName: "I elect to waive coverage",
        providerNumber: 1,
        disabled: setDisable(type, deps)
      });
      setPlans(filteredPlans);
      const selection = enrollments.selections.find(s => s.planType === type);
      let selectedPlan = filteredPlans.find((p) => enrollments.selections.find(s => s.planId === p.id));

      if(selectedPlan){
        if(selection?.planOption === "0" || (selection?.planOption === "5" && selection?.planType === PlanType.Medical) || (selection?.id === "WAIVED" && enrollments.enrollmentTypeId !== EnrollmentType.NewHire))
          selectedPlan = filteredPlans.find(s => s.id === 'WAIVED');
        setValue("planId", selectedPlan.id);
        setValue("planDescription", selectedPlan.name);
        setPlan(selectedPlan);
      }
    }

    trigger("planId")
    trigger("planOption");

  }, [enrollments, type, reset]);
  
  useEffect(()=> {
    const oldPlan = enrollments?.selections?.find(s => s.planType === type)
    if(count >0)
      if(!oldPlan)
        setPlan(null);
    setcount(count+1);
  }, [reset]);

  const setDisable = (planType, dependents) => {
    let output = false;
    dependents.forEach(d => {
      //console.log("test", d.courtOrdered, planType);
      if(isCourtOrdered(d.courtOrdered, planType))
      output = true;
        return;
    });

    return output;
  }

  
  const selectPlan = (e) => {
    const selectedPlan = plans.find((plan) => plan.id === e);
    setPlan(selectedPlan);
    setValue("planDescription", selectedPlan.name);
    
  };



  return (
    <>
      
      <PlanHeader planOption={planOption} planType={type} planId={plan?.id}/>
      {plans ? (
        <>
          <FormRadio label="Select Coverage Option" name="planId" options={plans} itemTextField="providerName" itemDisabledField="disabled" itemValueField="id" disabled={disabled} onChange={selectPlan} type={type} reset={reset} onReset={enrollments?.selections?.find(s => s.planType === type)}/>
          {type === PlanType.Medical && plan && plan.id === "MERCY"  ?
            <p className="text-xs ml-1 font-semibold">
              <WarningHexFilled20 aria-label="alert" className="inline-block mb-1 mr-1 text-amber-600" />

              Mercy's coverage area is limited to parts of Missouri (including the St Louis metro area), parts of Kansas, Arkansas and Oklahoma. </p> :
            <></>

          }
          <div className="my-8"></div>
          <Tiers 
            plan={plan} 
            planOption={planOption}
            setPlanOption={setPlanOption}
            type={type} 
            reset={reset} 
            setDisabled={setDisabled}
          />
        </>
      ) : (
        <StructuredListSkeleton />
      )}
    </>
  );
};

export default Plans;
